export const INDEX = "/en";

export const NOTICES = "/en/notices"
export const NOTICES_MENU = NOTICES + "/menu";
export const NOTICES_PAGE = NOTICES + "/no";

export const NEWS = "/en/news";
export const NEWS_MENU = NEWS + "/menu";
export const NEWS_PAGE = NEWS + "/no";

export const RECENT_RESEARCH = "/en/recent_research";
export const RECENT_RESEARCH_MENU = RECENT_RESEARCH + "/menu";

export const RESEARCH = "/en/research";
export const RESEARCH_DIRECTION = RESEARCH + "/direction";
export const RESEARCH_DIRECTION_PART = RESEARCH_DIRECTION + "/part";
export const RESEARCH_PLATFORM = RESEARCH + "/platform";
export const RESEARCH_FOUNDATION = RESEARCH + "/foundation";

export const MEMBERS = "/en/members";
export const MEMBERS_FACULTY = MEMBERS + "/faculty";
export const MEMBERS_PHD = MEMBERS + "/phd";
export const MEMBERS_MASTER = MEMBERS + "/master";
export const MEMBERS_UNDERGRADUATE = MEMBERS + "/undergraduate";
export const MEMBERS_ALUMNS = MEMBERS + "/alumni";

export const PUBLICATION = "/en/publication";
export const PUBLICATION_PAPER = PUBLICATION + "/paper";
export const PUBLICATION_PATENT = PUBLICATION + "/patent";
export const PUBLICATION_AWARDED = PUBLICATION + "/awarded";

export const ABOUTUS = "/en/about_us";

export const OTHERS = "/en/others";
export const OTHERS_RECREATION = OTHERS + "/recreation";
export const OTHERS_LINK = OTHERS + "/link";


export const SEMINAR='/en/smeinar'
export const SEMINAR_2025=SEMINAR+"/2025"
export const SEMINAR_2024=SEMINAR+"/2024"
export const SEMINAR_2023=SEMINAR+"/2023"
export const SEMINAR_2022=SEMINAR+"/2022"
export const SEMINAR_2021=SEMINAR+"/2021"
export const SEMINAR_2020=SEMINAR+"/2020"
export const SEMINAR_PAGE=SEMINAR

export default {
  INDEX,
  NOTICES, NOTICES_MENU, NOTICES_PAGE,
  NEWS, NEWS_MENU, NEWS_PAGE,
  RECENT_RESEARCH, RECENT_RESEARCH_MENU,
  RESEARCH, RESEARCH_DIRECTION, RESEARCH_DIRECTION_PART, RESEARCH_PLATFORM, RESEARCH_FOUNDATION,
  MEMBERS, MEMBERS_FACULTY, MEMBERS_PHD, MEMBERS_MASTER, MEMBERS_UNDERGRADUATE, MEMBERS_ALUMNS,
  PUBLICATION, PUBLICATION_PAPER, PUBLICATION_PATENT, PUBLICATION_AWARDED,
  ABOUTUS,
  OTHERS, OTHERS_RECREATION, OTHERS_LINK,
  SEMINAR,SEMINAR_2025,SEMINAR_2024,SEMINAR_2023,SEMINAR_2022,SEMINAR_2021,SEMINAR_2020,SEMINAR_PAGE
}
